import type { ValueOf } from '@weft/utils';

export const INTEGRATIONS_TYPES = {
  ERP: 'ERP',
  CRM: 'CRM',
  Payment: 'Payment',
  Communication: 'Communication',
} as const;

export type IntegrationType = ValueOf<typeof INTEGRATIONS_TYPES>;